<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you have any of the following chronic inflammatory conditions? <br /> <i>(check all that apply)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.chronicInflammatory">
      <b-form-checkbox v-model="survey.medicalConditions.chronicInflammatory.noCondition" @change="onNoConditionSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.chronicInflammatory.hasPsoriasis" @change="onPsoriasisSelected">
        Psoriasis
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.chronicInflammatory.hasRA" @change="onRASelected">
        Rheumatoid Arthritis
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.chronicInflammatory.hasAS" @change="onASSelected">
        Ankylosing Spondylitis
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.chronicInflammatory.hasHIV" @change="onHIVSelected">
        HIV / AIDS
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.medicalConditions.chronicInflammatory.hasSEL" @change="onSELSelected">
        Systemic Lupus Erythematosus
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      chronicInflammatory: {
        anyOptionRequired: anyOptionRequired((value) => value.noCondition || value.hasPsoriasis
          || value.hasRA || value.hasAS || value.hasHIV || value.hasSEL)
      }
    },

    computed: {
      ...mapState(["survey"]),

      chronicInflammatory() { return this.survey.medicalConditions.chronicInflammatory; }
    },

    methods: {
      onNoConditionSelected(value) {
        this.setOptions(value, false, false, false, false, false);
      },

      onPsoriasisSelected(value) {
        this.setOptions(false, value, this.chronicInflammatory.hasRA, this.chronicInflammatory.hasAS,
          this.chronicInflammatory.hasHIV, this.chronicInflammatory.hasSEL);
      },

      onRASelected(value) {
        this.setOptions(false, this.chronicInflammatory.hasPsoriasis, value, this.chronicInflammatory.hasAS,
          this.chronicInflammatory.hasHIV, this.chronicInflammatory.hasSEL);
      },

      onASSelected(value) {
        this.setOptions(false, this.chronicInflammatory.hasPsoriasis, this.chronicInflammatory.hasRA, value,
          this.chronicInflammatory.hasHIV, this.chronicInflammatory.hasSEL);
      },

      onHIVSelected(value) {
        this.setOptions(false, this.chronicInflammatory.hasPsoriasis, this.chronicInflammatory.hasRA,
          this.chronicInflammatory.hasAS, value, this.chronicInflammatory.hasSEL);
      },

      onSELSelected(value) {
        this.setOptions(false, this.chronicInflammatory.hasPsoriasis, this.chronicInflammatory.hasRA,
          this.chronicInflammatory.hasAS, this.chronicInflammatory.hasHIV, value);
      },

      setOptions(noCondition, hasPsoriasis, hasRA, hasAS, hasHIV, hasSEL) {
        this.survey.medicalConditions.chronicInflammatory.noCondition = noCondition;
        this.survey.medicalConditions.chronicInflammatory.hasPsoriasis = hasPsoriasis;
        this.survey.medicalConditions.chronicInflammatory.hasRA = hasRA;
        this.survey.medicalConditions.chronicInflammatory.hasAS = hasAS;
        this.survey.medicalConditions.chronicInflammatory.hasHIV = hasHIV;
        this.survey.medicalConditions.chronicInflammatory.hasSEL = hasSEL;

        this.survey.medicalConditions.chronicInflammatory.hasInflamation = !noCondition;
      }
    }
  };
</script>